import { TailwindExtensionWallet } from '.';
import { tailwind_extension_info } from './constants';
export const wallets = [
    new TailwindExtensionWallet(tailwind_extension_info),
];
